import {PayloadAction, createSlice} from "@reduxjs/toolkit";

import {HYDRATE} from "../index";
import {ConfigState} from "../types";

const initialState = {
  locations: [],
  pageLoaded: false,
  locationsSorted: false,
} as ConfigState;

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action: PayloadAction<Partial<ConfigState>>) => ({
      ...state,
      ...action.payload,
    }),
  },

  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => ({
      ...state,
      ...action.payload.config,
    }));
  },
});

export const {setConfig} = configSlice.actions;

export default configSlice.reducer;
